const messages = {
  title: "Bónuszszorzó",
  bandBonusTitle: "Bónusz gumiabroncsonként szorzóval",
  amountLabel: "Min. gumiabroncsok száma (*)",
  label: "Bónuszszorzó",
  desc: "Bridgestone és Firestone gumiabroncsok száma. Firestone gumiabroncsokra nincs euró bónusz.",
  goals: {
    loyal: "Hűséges",
    bronze: "Bronz",
    silver: "Ezüst",
    gold: "Arany",
    platinum: "Platina",
  },
  andMore: "és több",
  chooseTarget: "Kiválaszt",
  selectTarget: "Válassza ki itt {year} éves célját:",
  multiplication: "A bónusz szorzója: <b>{factor}</b>",
  minTyres: "<b>Minimum:</b> {tyre} gumiabroncs",
};

export default {
  messages,
};
